import React, { useEffect, useState } from "react";
import styles from "./NewsDetail2.module.css";
import { useParams } from "react-router-dom";
import pagesService from "../../services/pages";
import { formatDate } from "../home-page/gallery-list/gallery-card/GalleryCard";
import RelatedItems from "./related-items/RelatedItems";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import SEO from "../../components/SEO/SEO";
import useDeviceWidth from "../../components/device-width/UseDeviceWidth";
import AdjustFontSize from "../../components/adjust-font-size/AdjustFontSize";
import ShareButtons from "../../components/share-buttons/ShareButtons";

const NewsDetail2 = () => {
  const { slug } = useParams();
  const [blogData, setBlogData] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [responsiveHtml, setResponsiveHtml] = useState("");
  const width = useDeviceWidth();

  useEffect(() => {
    if (blogData?.description) {
      setResponsiveHtml(AdjustFontSize(blogData.description, width));
    }
  }, [blogData, width]);

  useEffect(() => {
    let isMounted = true; // Prevents state updates if the component unmounts

    const fetchData = async () => {
      try {
        setLoading(true);

        const [blogRes, blogsRes] = await Promise.all([
          pagesService.getBySlug(slug),
          pagesService.getAll(`?category=6780be1dc8a5ce81775c05c2`),
        ]);

        if (isMounted) {
          console.log("FETCHED BLOG DATA:", blogRes?.data);
          console.log("FETCHED BLOGs:", blogsRes?.data);

          setBlogData(blogRes?.data);
          setBlogs(blogsRes?.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Cleanup function to prevent memory leaks
    };
  }, [slug]);

  return (
    <>
      {blogData && <SEO seo={blogData} />}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className={styles.container}>
          <div className={styles.description}>
            <div className={styles.divA}>
              <section className={styles.banner}>
                <div className={styles.bannerBack}>
                  <img
                    src={
                      width > 568
                        ? "/img/designs/detail-back2.png"
                        : "/img/designs/detail-back2-mob.png"
                    }
                    alt="bannerBack"
                    className={styles.bannerBack}
                  />
                </div>
                <div className={styles.imageSection}>
                  <img
                    data-aos="fade"
                    data-aos-delay="200"
                    src={
                      blogData?.images?.find(
                        (item) => item?.mainImage === "yes"
                      )?.url
                    }
                    alt={
                      blogData?.images?.find(
                        (item) => item?.mainImage === "yes"
                      )?.imageTag
                    }
                  />
                </div>
                <div className={styles.titleSection}>
                  {/* <div
                            className={styles.imageDiv}
                            data-aos="fade-down"
                            data-aos-delay="200"
                          >
                            <img
                              src={service.icon || "/img/default-icon.png"}
                              alt={service.image?.imageTag || "Service Icon"}
                              loading="lazy"
                            />
                          </div> */}
                  <p data-aos="fade-right" data-aos-delay="200">
                    {blogData.title}
                  </p>
                </div>
              </section>
              {/* <div className={styles.div1}>
                          <img
                            src="https://via.placeholder.com/150"
                            alt="Service"
                            className={styles.div1Image}
                          />
                          <div className={styles.div1Content}>
                            <span className={styles.date}>June 4, 2025</span>
                            <h2 className={styles.title}>Comprehensive Health Checkup</h2>
                          </div>
                        </div> */}
              <div
                className={`${styles.serviceContent} detail-description`}
                dangerouslySetInnerHTML={{ __html: responsiveHtml }}
              />
              <ShareButtons />
            </div>
            <div className={styles.divB}>
              <RelatedItems
                data={blogs?.filter((blog) => blog?.slug !== slug)}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsDetail2;
